export const PARDOT_ACCOUNTS_PAGE_TITLE = 'Select Pardot Record Type(s)';
export const PARDOT_SUMMARY_LOAD = `Please select the record type(s) from your 
    Pardot account you would like us to match to your segment.`;
